<template>
    <div class="main-container">
        <div class="filter-container">
            <el-select class="filter-item" v-model="filters.type" placeholder="充值类型">
                <el-option :value="3+''" label="全部"></el-option>
                <el-option :value="0+''" label="充值"></el-option>
            </el-select>
            <el-select class="filter-item" v-model="filters.status" placeholder="审核状态">
                <el-option :value="3+''" label="全部"></el-option>
                <el-option :value="0+''" label="待审核"></el-option>
                <el-option :value="1+''" label="审核成功"></el-option>
                <el-option :value="2+''" label="审核失败"></el-option>
            </el-select>
             <el-date-picker class="filter-item" v-model="filters.start_date" placeholder="选择开始日期" value-format="YYYY-MM-DD"></el-date-picker>
             <span class="filter-item">-</span>
             <el-date-picker class="filter-item" v-model="filters.end_date" placeholder="选择结束日期" value-format="YYYY-MM-DD"></el-date-picker>
            <el-select class="filter-item" filterable v-model="filters.channel_no" clearable placeholder="请选择渠道">
                <el-option v-for="item in channelList" :key="item.id" :label="item.channel_name" :value="item.channel_no"></el-option>
            </el-select>
            <el-button class="filter-btn" type="primary" @click="search()">搜索</el-button>

        </div>
        <el-table :data="tableData" border style="width:100%">
            <el-table-column prop="id" label="充值ID"></el-table-column>
            <el-table-column prop="admin_name" label="上传人"></el-table-column>
            <el-table-column prop="check_name" label="审核人"></el-table-column>
            <el-table-column prop="price" label="充值总金额"></el-table-column>
            <el-table-column prop="number" label="充值人数"></el-table-column>
            <el-table-column prop="channel_no" label="渠道"></el-table-column>
            <el-table-column prop="created_at" label="充值时间"></el-table-column>
            <el-table-column prop="updated_at" label="修改时间"></el-table-column>
            <el-table-column label="审核状态">
                <template #default="scope">
                    {{ RechargeCheckStatus[scope.row.status] }}
                </template>
            </el-table-column>
            <el-table-column label="充值类型">
                <template #default="scope">
                    {{ scope.row.type == 0 ? '金额充值' : '' }}
                </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注"></el-table-column>

            <el-table-column label="操作" width="190">
                <template #default="scope">
                    <div class="action-list">
                        <el-button type="primary" size="small" @click="router.push(`/partner/recharge-info?id=${scope.row.id}&is_check=1`)">充值详情</el-button>
                        <el-button v-if="scope.row.status != 1" type="primary" size="small" @click="rechargeCheck(scope.$index, scope.row)">充值审核</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <Pagination :currentPage="filters.page" :total="total" @pageChange="onPageChange" @sizeChange="onSizeChange" />
        <el-dialog title="充值审核" v-model="dialogRechargeCheck">
            <el-form ref="form" :v-model="checkData" label-width="120px">
                <el-form-item label="审核状态：">
                    <el-radio-group v-model="checkData.check_status">
                        <el-radio :label="0">待审核</el-radio>
                        <el-radio :label="1">审核成功</el-radio>
                        <el-radio :label="2">审核失败</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="备注：" v-if="checkData.check_status == 2">
                    <el-input v-model="checkData.remark" type="textarea"></el-input>
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="dialogRechargeCheck = false">取 消</el-button>
                    <el-button type="success" @click="submitRechargeCheck()">确 定</el-button>
                </span>
            </template>
        </el-dialog>

        <!-- <el-pagination
            @current-change="handleCurrentChange"
            v-model:currentPage="filters.page"
            :page-size="filters.limit"
            layout="total, prev, pager, next, jumper"
            :total="total">
        </el-pagination> -->
    </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue'
import { useRouter } from 'vue-router'
import { defineComponent, getCurrentInstance, toRefs, reactive } from 'vue'
import { useStore } from '@/store/index'
import { UserMutationTypes } from '@/store/modules/user/mutation-types'
import { joinParams } from '@/utils/index'
import { RechargeCheckStatus } from '@/enums/coupon'
import Keys from '@/constant/key'
export default defineComponent({
name: 'RechargeList',
components: {Pagination},
setup() {
    const { proxy } = getCurrentInstance()
    const router = useRouter()
    const store = useStore()

    const data = reactive({
        filters: {
            type:       null,   // 充值类型
            channel_no: '',     // 渠道号
            status:     null,   // 审核状态
            start_date: '',     // 开始日期
            end_date:   '',     // 结束日期
            limit:      10,     // 每页条数
            page:       1,      // 当前页码
        },
        checkData:{
            check_status:'',
            remark:'',
            recharge_id:''
        },
        tableData: [],
        channelList:[],
        total: 0,
        dialogRechargeCheck:false,
        
        // 翻页
        handleCurrentChange(val) {
            data.filters.page = val
            data.getList();
        },
        // 获取表格数据
        getList(){
            proxy.$http.get(`/admin/recharge/getRechargeList?${joinParams(data.filters)}`).then(res => {
                if(res.code == 0){
                    data.tableData = res.data;
                    data.total = res.count
                }else{
                    data.tableData = [];
                }
                
            })
        },
        // 获取渠道列表
        getChannelList:()=>{
            proxy.$http.get(`/admin/user/getChannelList`).then((res) => {
                if(res.code == 0){
                    data.channelList = res.data;
                }else{
                    proxy.$message({type:'error',message:res.msg});
                }
            })
        },
        // 搜索
        search(){
            data.filters.page = 1
            data.getList()
        },
        onPageChange (val) {
            data.filters.page = val
            data.getList()
        },
        onSizeChange  (val) {
            data.filters.limit = val
            data.getList()
        },
        rechargeInfo(index,row){
            router.push(`/partner/recharge-info?id=${row.id}&is_check=1`);
        },
        rechargeCheck(index,row){
            data.checkData.check_status = row.status;
            data.checkData.remark = '';
            data.checkData.recharge_id = row.id;
            data.dialogRechargeCheck = true;
        },
        submitRechargeCheck(){
            if(data.checkData.check_status != 0){
                var msg = '';
                if(data.checkData.check_status == 1){
                    msg = '确定审核成功吗，审核成功后开始给用户充值！';
                }else if(data.checkData.check_status == 2){
                    if(data.checkData.remark){
                        msg = '确定审核不通过吗？';
                    }else{
                        msg = '审核不通过，请填写原因！';
                        proxy.$message({type:'error',message:res.msg});
                        return;
                    }
                }
                proxy.$confirm(`${msg}`, '提示', {
                    type: 'warning',
                    dangerouslyUseHTMLString: true
                }).then(() => {
                     proxy.$http.post(`/admin/recharge/submitRechargeCheck`, data.checkData).then((res) => {
                        if(res.code == 0){
                            proxy.$message({type:'success',message:res.msg});
                            
                            // 菜单提醒数字减一
                            store.commit(UserMutationTypes.MINUS_MENU_WARNING_ITEM, 'sgcc_recharges')

                            location.reload();
                        }else{
                            proxy.$message({type:'error',message:res.msg});
                        }
                    })
                });
            }
        }
    })
    data.getList()
    data.getChannelList()

    return { ...toRefs(data), Keys, store, RechargeCheckStatus,router }
}
})
</script>

<style lang="stylus" scoped></style>